import { makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import { lightGrey } from "../../../../../../../infrastructure/theme/customColors";

interface Props {
  borderType: string;
  labelStyle: string;
  dataStyle: string;
}

export const useStyles = makeStyles<Theme, Props>(() => ({
  row: {
    width: "100%",
    padding: "24px 0px 26px 0px",
    borderBottom: ({ borderType }) =>
      borderType === "slim"
        ? `1px solid ${lightGrey}`
        : `5px solid ${lightGrey}`,
  },
  container: {
    width: "100%",
  },
  dataContainer: {
    marginLeft: "auto",
  },
  labelInfo: {
    fontWeight: ({ labelStyle }) => (labelStyle === "bold" ? 700 : 400),
  },
  dataInfo: {
    fontWeight: ({ dataStyle }) => (dataStyle === "bold" ? 700 : 400),
    marginLeft: "auto",
  },
  subLabelInfo: {
    color: "#929FAD",
  },
  breakdownContainer: {
    marginTop: "22px",
  },
  extraEmployeeLabel: {
    fontSize: "14px",
    color: "#4B5D72",
  },
  extraEmployeeData: {
    fontSize: "14px",
    color: "#4B5D72",
    marginLeft: "auto",
  },
  extraLabel: {
    fontSize: "14px",
    color: "#929FAD",
  },
  extraData: {
    fontSize: "14px",
    color: "#929FAD",
    marginLeft: "auto",
  },
}));

export const Accordion = withStyles({
  root: {
    width: "100%",
    boxShadow: "none",
    "& .MuiAccordionSummary-root": {
      padding: 0,
    },
    "& .MuiAccordionDetails-root": {
      padding: 0,
    },
  },
})(MuiAccordion);
